import { Locale } from 'contentful';
import MarketRestrictionUtil from '@app/utils/MarketRetrictionUtil';
import { TypeContactSkeleton, TypeMedia } from '@/@types/generated/contentful';
import IRawContact from '../types/base/IRawContact';
import MultiLocaleService from './base/MultiLocaleService';

export default class ContactService extends MultiLocaleService {
	public async getContacts(): Promise<Record<string, IRawContact[]>> {
		// Load contact entries (not contentful users because management api would be needed)
		const contacts = await this.deliveryClient.withAllLocales.getEntries<TypeContactSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'contact',
		});

		const contactsByLocaleCode: Record<string, IRawContact[]> = {};

		this.locales.forEach((locale: Locale): void => {
			contactsByLocaleCode[locale.code] = contacts.items.map(
				(contact): IRawContact => {
					const image = contact.fields.image as Record<string, TypeMedia<'WITH_ALL_LOCALES'>> | undefined;
					const markets = contact.fields.markets as Record<string, Record<string, boolean>> | undefined;


					return {
						...this.mapToSingleLocaleObject(contact.fields, locale),
						id: contact.sys.id,
						image: image?.de.fields.asset.de,
						markets: MarketRestrictionUtil.mapMarketsObjectToArray((markets ?? {}).de)
					};
				}
			);
		});

		return contactsByLocaleCode;
	}
}

